import { LoadingBox } from "@assets/tsx/loadingBox/loadingBox";
import Button from "@widgets/button/button";
import React, { useEffect, useState } from "react";
export default function Table({ body, footer, header, colCount, hovered, style, cellPadding, layout, colWidth }) {
    const [rowCount, setRowCount] = useState(null);
    const [rowStyles, setRowStyles] = useState(null);
    useEffect(() => {
        const bodyCount = (body === null || body === void 0 ? void 0 : body.rowCount) || 0;
        const headerCount = (header === null || header === void 0 ? void 0 : header.rowCount) || 0;
        const footerCount = (footer === null || footer === void 0 ? void 0 : footer.rowCount) || 0;
        const totalCount = bodyCount + headerCount + footerCount;
        setRowCount({
            body: bodyCount,
            header: headerCount,
            footer: footerCount,
            total: totalCount,
        });
        setRowStyles({
            body: (body === null || body === void 0 ? void 0 : body.rowStyles) || {},
            header: (header === null || header === void 0 ? void 0 : header.rowStyles) || {},
            footer: (footer === null || footer === void 0 ? void 0 : footer.rowStyles) || {},
        });
    }, [colCount, body, footer, header]);
    if (!(rowCount === null || rowCount === void 0 ? void 0 : rowCount.total)) {
        return React.createElement(LoadingBox, { style: { height: 400 } });
    }
    const tableClassList = Object.keys(rowCount).reduce((agr, part) => {
        if (rowCount[part] <= 0) {
            return agr;
        }
        return `${agr} --has-${part}`;
    }, ' ');
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `ltg-table-wrap ltg-table--${style || 'default'}` },
            React.createElement("table", { style: { tableLayout: layout || 'fixed' }, className: `ltg-table${tableClassList}`, cellPadding: cellPadding || null },
                layout === 'fixed' && colWidth && (React.createElement(ColWidths, { widths: colWidth, colCount: colCount })),
                (rowCount === null || rowCount === void 0 ? void 0 : rowCount.header) > 0 && (React.createElement(TableContent, { tag: "thead", hovered: (hovered === null || hovered === void 0 ? void 0 : hovered.part) === 'header' ? hovered.compoundIndex : null, rowCount: rowCount.header, colCount: colCount, data: (header === null || header === void 0 ? void 0 : header.data) || {}, rowStyles: rowStyles === null || rowStyles === void 0 ? void 0 : rowStyles.header })),
                (rowCount === null || rowCount === void 0 ? void 0 : rowCount.body) > 0 && (React.createElement(TableContent, { tag: "tbody", hovered: (hovered === null || hovered === void 0 ? void 0 : hovered.part) === 'body' ? hovered.compoundIndex : null, rowCount: rowCount.body, colCount: colCount, data: (body === null || body === void 0 ? void 0 : body.data) || {}, rowStyles: rowStyles === null || rowStyles === void 0 ? void 0 : rowStyles.body })),
                (rowCount === null || rowCount === void 0 ? void 0 : rowCount.footer) > 0 && (React.createElement(TableContent, { tag: "tfoot", hovered: (hovered === null || hovered === void 0 ? void 0 : hovered.part) === 'footer' ? hovered.compoundIndex : null, rowCount: rowCount.footer, colCount: colCount, data: (footer === null || footer === void 0 ? void 0 : footer.data) || {}, rowStyles: rowStyles === null || rowStyles === void 0 ? void 0 : rowStyles.footer }))))));
}
function TableContent({ tag, rowCount, colCount, data, hovered, rowStyles, className }) {
    return React.createElement(tag, { 'data-row-count': rowCount % 2 === 0 ? 'even' : 'odd', className: `ltg-table-${tag}${className ? ` ${className}` : ''}` }, React.createElement(Content, null));
    function Content() {
        return (React.createElement(React.Fragment, null, new Array(rowCount).fill(undefined).map((row, rowIndex) => {
            const rowStyle = rowStyles[rowIndex];
            const borderStyle = (rowStyle === null || rowStyle === void 0 ? void 0 : rowStyle.border) || {};
            const borderStyles = Object.keys(borderStyle).reduce((agr, dir) => {
                var _a, _b, _c;
                const capDir = dir.charAt(0).toUpperCase() + dir.slice(1);
                if ((rowStyle === null || rowStyle === void 0 ? void 0 : rowStyle.border[dir]) === null) {
                    return Object.assign(Object.assign({}, agr), { [`border${capDir}`]: 'none' });
                }
                return Object.assign(Object.assign({}, agr), { [`border${capDir}Width`]: ((_a = rowStyle.border[dir]) === null || _a === void 0 ? void 0 : _a.width) || 0, [`border${capDir}Color`]: ((_b = rowStyle.border[dir]) === null || _b === void 0 ? void 0 : _b.color) || '#d0d3d4', [`border${capDir}Style`]: ((_c = rowStyle.border[dir]) === null || _c === void 0 ? void 0 : _c.style) || 'solid' });
            }, {});
            return (React.createElement("tr", { style: Object.assign({}, borderStyles), className: "ltg-table-row", key: tag + '-row-' + rowIndex }, new Array(colCount).fill(undefined).map((col, colIndex) => {
                var _a, _b;
                const compoundIndex = `${rowIndex}:${colIndex}`;
                const preventRender = typeof data[compoundIndex] === 'string';
                if (preventRender) {
                    return null;
                }
                const cellData = data[`${rowIndex}:${colIndex}`] || {};
                const rowSpan = data ? (_a = data[compoundIndex]) === null || _a === void 0 ? void 0 : _a.rowSpan : null;
                const colSpan = data ? (_b = data[compoundIndex]) === null || _b === void 0 ? void 0 : _b.colSpan : null;
                const borderRadius = (cellData === null || cellData === void 0 ? void 0 : cellData.borderRadius) || {};
                const styleHovered = hovered && hovered === compoundIndex ? ' --hovered' : '';
                return React.createElement(tag === 'thead' ? 'th' : 'td', {
                    className: `ltg-table-cell${styleHovered} ltg-table-cell--${rowIndex}-${colIndex}`,
                    colSpan: colSpan,
                    rowSpan: rowSpan,
                    key: tag + '-col-' + colIndex,
                    style: {
                        borderTopLeftRadius: +(borderRadius === null || borderRadius === void 0 ? void 0 : borderRadius.nw) || null,
                        borderTopRightRadius: +(borderRadius === null || borderRadius === void 0 ? void 0 : borderRadius.ne) || null,
                        borderBottomRightRadius: +(borderRadius === null || borderRadius === void 0 ? void 0 : borderRadius.se) || null,
                        borderBottomLeftRadius: +(borderRadius === null || borderRadius === void 0 ? void 0 : borderRadius.sw) || null,
                        background: (cellData === null || cellData === void 0 ? void 0 : cellData.backgroundColor) || null,
                        textAlign: (cellData === null || cellData === void 0 ? void 0 : cellData.textAlign) || null,
                        verticalAlign: (cellData === null || cellData === void 0 ? void 0 : cellData.verticalAlign) || null,
                    }
                }, (cellData === null || cellData === void 0 ? void 0 : cellData.content) ? React.createElement("div", { className: "ltg-table-cell--text", dangerouslySetInnerHTML: { __html: (cellData === null || cellData === void 0 ? void 0 : cellData.content) || ' ' } }) : null, React.createElement(CellElements, { elements: cellData === null || cellData === void 0 ? void 0 : cellData.elements }));
            })));
        })));
    }
}
function ColWidths({ widths, colCount }) {
    if (!colCount)
        return null;
    const cols = Array(colCount).fill(undefined);
    return (React.createElement("colgroup", null, cols.map((_, colIndex) => {
        var _a, _b, _c;
        return (React.createElement("col", { key: 'colWidth' + colIndex, style: { width: ((_a = widths[colIndex]) === null || _a === void 0 ? void 0 : _a.value) ? `${(_b = widths[colIndex]) === null || _b === void 0 ? void 0 : _b.value}${(_c = widths[colIndex]) === null || _c === void 0 ? void 0 : _c.unit}` : null } }));
    })));
}
function CellElements({ elements }) {
    if (!elements)
        return null;
    if ((elements === null || elements === void 0 ? void 0 : elements.length) <= 0)
        return null;
    const available = {
        'ltg-button': Button,
    };
    return (React.createElement("div", { className: "ltg-table-cell--elements" }, elements.map((elData, i) => {
        const elName = elData._type;
        const Element = available[elName];
        if (!Element)
            return null;
        return React.createElement(Element, Object.assign({ key: elName + i }, elData));
    })));
}
